module.exports = __webpack_public_path__ + "img/user1.e3d2490d.png";